import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormViewParams } from '../models/state.model';
import { ViewParams } from '../../models/ViewParams';
import { FormContextValue } from '../../contexts/FormContext';

export interface DialogViewParams extends FormViewParams {
  id: string;
}

type DialogPayloadType = PayloadAction<DialogViewParams>;

export type DialogViewStack = Array<DialogViewParams>;

const initialState: DialogViewStack = [];

const DialogViewsSlice = createSlice({
  name: 'dialogViewStack',
  initialState,
  reducers: {
    openDialog(state, action: DialogPayloadType) {
      state.push(action.payload);
      return state;
    },
    setDialogViewData(state, action: PayloadAction<ViewParams>) {
      if (state.length) {
        state[state.length - 1].dataRequest = action.payload;
      }

      return state;
    },
    setDialogContext(state, action: PayloadAction<FormContextValue>) {
      if (state.length) {
        const dialog = state[state.length - 1];

        if (!dialog.context) {
          dialog.context = [];
        }
        dialog.context.push(action.payload);
      }
    },
    closeDialog(state) {
      state.pop();
    },
    clearDialogsStack() {
      return initialState;
    },
  },
});

export const { openDialog, setDialogContext, closeDialog, setDialogViewData, clearDialogsStack } =
  DialogViewsSlice.actions;

const DialogsViewsState = DialogViewsSlice.reducer;
export default DialogsViewsState;
